<template>
    <div>
        <v-progress-linear :indeterminate="true" v-if="loading"></v-progress-linear>
        <v-container v-else>
            <form @submit.prevent="add_categories" autocomplete="off">
                <v-layout row wrap>
                    <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="categories.category_name" type="text"
                            :label="$store.getters.lang.data.category_name" outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex>


                    <!-- <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="categories.category_image" type="text"
                            :label="$store.getters.lang.data.category_image" outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex> -->


                    <!-- <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field v-model="categories.category_color" type="text"
                            :label="$store.getters.lang.data.category_color" outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex> -->


                    <!-- <v-flex xs12 lg2 xl2 md3 sm4>
                        <v-text-field :append-icon="categories.category_icon" v-model="categories.category_icon" type="text"
                            :label="$store.getters.lang.data.category_icon" outlined class="mx-1" filled required rounded>
                        </v-text-field>
                    </v-flex> -->


                    <v-flex xs12 lg6 xl6 md6 sm6>
                        <v-textarea rows="1" auto-grow v-model="categories.category_keywords" type="text"
                            :label="$store.getters.lang.data.category_keywords" outlined class="mx-1" filled required rounded>
                        </v-textarea>
                    </v-flex>


                    <v-flex xs12 lg2 xl2 md2 sm4>
                        <v-btn rounded color="primary" type="submit" x-large>{{$store.getters.lang.data.add_btn}}
                            categories</v-btn>
                    </v-flex>
                </v-layout>
            </form>
            <v-layout row wrap mt-5>
                <v-flex xs12>
                    <v-card>
                        <v-card-title primary-title>
                            {{$store.getters.lang.data.categories}}
                            <v-spacer></v-spacer>
                            <v-text-field autocomplete="off" v-model="search" append-icon="fas fa-search">
                            </v-text-field>
                        </v-card-title>
                        <v-card-text>
                            <v-data-table :headers="headers" :search="search" :items="rows" class="elevation-0"
                                item-key="category_id">
                                <template v-slot:[`item.category_id`]="{ item }">
                                    <div>
                                        <v-btn :to="'/items-list?category_id='+item.category_id" text color="green"
                                            class="mx-1" rounded>
                                            Show Items
                                        </v-btn>
                                        <v-btn icon color="error" :disabled="$store.state.auth.user.admin_role != 'admin'" class="mx-1" @click="select_categories(item)" rounded>
                                            <v-icon>mdi-delete-outline</v-icon>
                                        </v-btn>
                                        <v-btn :to="'/categories-list/'+item.category_id" icon color="secondary"
                                            class="mx-1" rounded>
                                            <v-icon>mdi-pencil-outline</v-icon>
                                        </v-btn>
                                    </div>
                                </template>
                                <template v-slot:[`item.category_icon`]="{ item }">
                                    <div>
                                        <v-avatar size="45">
                                            <img :src="$api+'/uploads/'+item.category_image" alt="not uploades">
                                        </v-avatar>

                                    </div>
                                </template>
                            </v-data-table>
                        </v-card-text>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
        <v-dialog v-model="delete_dialog" persistent max-width="290">
            <v-card>
                <v-card-title>
                    {{$store.getters.lang.data.delete_question}}
                </v-card-title>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="error" class="elevation-0" @click="delete_dialog = false">
                        {{$store.getters.lang.data.cancel_btn}}
                    </v-btn>
                    <v-btn color="green darken-1" text @click="delete_categories(selected_categories.category_id)">
                        {{$store.getters.lang.data.yes_btn}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="snackbar.value" :color="snackbar.color">
            {{snackbar.text}}
        </v-snackbar>
    </div>
</template>
<script>
    import controller from './../../controller/categories'
    export default {
        data() {
            return {
                categories: {},
                search: '',
                loading: true,
                snackbar: {
                    value: false,
                    text: '',
                    color: ''
                },
                selected_categories: {},
                delete_dialog: false,
                headers: [

                    {
                        text: '#',
                        align: 'start',
                        sortable: true,
                        value: 'category_sort',
                    },
                    {
                        text: this.$store.getters.lang.data.category_name,
                        align: 'start',
                        sortable: true,
                        value: 'category_name',
                    },





                    // {
                    //     text: this.$store.getters.lang.data.category_image,
                    //     align: 'start',
                    //     sortable: true,
                    //     value: 'category_image',
                    // },


                    // {
                    //     text: this.$store.getters.lang.data.category_color,
                    //     align: 'start',
                    //     sortable: true,
                    //     value: 'category_color',
                    // },


                    {
                        text: this.$store.getters.lang.data.category_icon,
                        align: 'start',
                        sortable: true,
                        value: 'category_icon',
                    },


                    {
                        text: this.$store.getters.lang.data.category_keywords,
                        align: 'start',
                        sortable: true,
                        value: 'category_keywords',
                    },
                    {
                        text: '#',
                        align: 'start',
                        sortable: true,
                        value: 'category_id',
                    },


                ],
            }
        },
        computed: {
            rows() {
                return this.$store.getters.categories
            },


        },
        mounted() {
            this.read_categories();
        },
        methods: {
            add_categories() {
                controller.add_categories(this.categories).then(r => {
                    if (r.data) {
                        this.categories = {}
                        this.$store.state.categories.push(
                            r.data.new_data
                        )
                        this.snackbar = {
                            value: true,
                            text: 'categories Added',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Fail to add categories',
                            color: 'error'
                        }
                    }
                })
            },
            delete_categories(category_id) {
                controller.delete_categories(category_id).then(r => {
                    this.delete_dialog = false
                    if (r.data) {
                        this.$store.state.categories = this.$store.state.categories.filter(f => {
                            return f.category_id != category_id
                        })
                        this.snackbar = {
                            value: true,
                            text: 'categories Deleted',
                            color: 'success'
                        }
                    } else {
                        this.snackbar = {
                            value: true,
                            text: 'Delete Faild',
                            color: 'error'
                        }
                    }
                })
            },
            read_categories() {
                this.loading = true
                controller.get_categories().then(r => {
                    // this.rows = r.data.rows
                    this.loading = false
                })
            },
            select_categories(i) {
                this.selected_categories = i
                this.delete_dialog = true
            },
        },
    }
</script>